import * as React from "react";
import { singleton } from "logic/singleton";
const ReportRenderPageResults = React.createContext(void 0);
export default singleton("contexts.ReportRenderPageResults", () => ReportRenderPageResults);
